var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashinvoiceWhiteLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 37,
    viewBox: "0 0 166 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M57.2496 15.013C56.7975 12.6498 55.0267 11.4682 52.8038 11.4682C49.0361 11.4682 47.416 14.7373 47.416 18.2034C47.416 21.9846 49.0361 25.1749 52.8415 25.1749C55.5918 25.1749 57.2496 23.1268 57.438 20.3697H59.5479C59.1334 24.5447 56.6845 27.0261 52.6531 27.0261C47.7174 27.0261 45.3062 23.2056 45.3062 18.3609C45.3062 13.5163 47.9435 9.61694 52.8415 9.61694C56.157 9.61694 58.9074 11.4682 59.3972 15.013H57.2496Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M72.0569 26.5564C71.7178 26.7534 71.2657 26.8715 70.7005 26.8715C69.7209 26.8715 69.0805 26.3201 69.0805 25.0203C68.0255 26.3201 66.6315 26.8715 65.0114 26.8715C62.9015 26.8715 61.2061 25.9262 61.2061 23.4842C61.2061 20.7665 63.1276 20.1757 65.0867 19.7818C67.1589 19.3485 68.9674 19.5061 68.9674 18.0094C68.9674 16.2763 67.5734 16.0006 66.4054 16.0006C64.7853 16.0006 63.6174 16.5126 63.542 18.2851H61.6582C61.7712 15.2916 63.9564 14.2676 66.5184 14.2676C68.5906 14.2676 70.8512 14.7402 70.8512 17.5761V23.7599C70.8512 24.7052 70.8512 25.0991 71.4541 25.0991C71.6424 25.0991 71.8308 25.0597 72.0192 24.9809V26.5564H72.0569ZM68.9674 20.412C67.498 21.5542 63.2406 20.4514 63.2406 23.4054C63.2406 24.7052 64.2955 25.1779 65.4635 25.1779C67.9502 25.1779 68.9674 23.563 68.9674 22.4601V20.412Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M74.9566 22.8148C75.0319 24.5872 76.5013 25.1386 78.0461 25.1386C79.214 25.1386 80.8341 24.8629 80.8341 23.3662C80.8341 20.2546 73.2988 22.3815 73.2988 17.7338C73.2988 15.3312 75.5594 14.3071 77.5939 14.3071C80.1936 14.3071 82.1151 15.1343 82.3035 18.0883H80.4197C80.3066 16.5522 78.988 16.0796 77.7446 16.0796C76.6144 16.0796 75.2957 16.3947 75.2957 17.6157C75.2957 18.9942 77.2925 19.3093 79.0633 19.7032C80.9472 20.1365 82.831 20.806 82.831 23.1299C82.831 26.0052 80.269 26.9111 77.933 26.9111C75.3334 26.9111 73.1858 25.8082 73.0728 22.8542H74.9566V22.8148Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M84.9414 10.0081H86.8252V16.3494H86.8629C87.4657 14.8921 89.1235 14.3013 90.4799 14.3013C93.494 14.3013 94.4359 16.1131 94.4359 18.7127V26.6295H92.5521V18.4763C92.5521 16.9796 91.6478 16.0737 90.2161 16.0737C87.9178 16.0737 86.8252 17.6886 86.8252 19.8549V26.6295H84.9414V10.0081Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M99.2964 12.4107H97.4126V10.0081H99.2964V12.4107ZM97.4126 14.577H99.2964V26.5901H97.4126V14.577Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M102.235 14.5827H104.006V16.4733H104.043C104.835 14.9765 106.116 14.2676 107.773 14.2676C110.787 14.2676 111.729 16.0794 111.729 18.679V26.5958H109.846V18.4426C109.846 16.9459 108.941 16.04 107.51 16.04C105.211 16.04 104.119 17.6549 104.119 19.8212V26.5958H102.235V14.5827Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M119.793 26.628H117.759L113.501 14.5754H115.611L118.852 24.6192H118.889L122.016 14.5754H124.013L119.793 26.628Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M130.681 14.3027C134.335 14.3027 136.257 17.0598 136.257 20.6047C136.257 24.1102 134.335 26.8673 130.681 26.8673C127.026 26.8673 125.104 24.1102 125.104 20.6047C125.104 17.0598 127.064 14.3027 130.681 14.3027ZM130.681 25.1342C132.677 25.1342 134.26 23.5194 134.26 20.6047C134.26 17.69 132.64 16.0358 130.681 16.0358C128.684 16.0358 127.101 17.69 127.101 20.6047C127.101 23.5194 128.721 25.1342 130.681 25.1342Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M140.514 12.4107H138.631V10.0081H140.514V12.4107ZM138.631 14.577H140.514V26.5901H138.631V14.577Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M151.251 18.4428C150.949 16.9461 149.97 16.0402 148.387 16.0402C145.637 16.0402 144.808 18.3246 144.808 20.7273C144.808 22.9723 145.75 25.1386 148.161 25.1386C150.008 25.1386 151.063 24.0358 151.326 22.224H153.248C152.833 25.178 151.1 26.9111 148.161 26.9111C144.658 26.9111 142.774 24.3903 142.774 20.7667C142.774 17.143 144.544 14.3071 148.199 14.3071C150.836 14.3071 152.871 15.5675 153.172 18.4428H151.251Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M165.231 22.8104C164.703 25.4887 162.932 26.9067 160.295 26.9067C156.64 26.9067 154.87 24.2283 154.794 20.5653C154.794 16.9417 157.055 14.3027 160.22 14.3027C164.289 14.3027 165.532 18.2809 165.419 21.1955H156.791C156.716 23.283 157.846 25.1342 160.37 25.1342C161.953 25.1342 163.008 24.3859 163.347 22.771H165.231V22.8104ZM163.384 19.4625C163.271 17.5719 161.953 16.0752 160.069 16.0752C158.11 16.0752 156.904 17.6113 156.791 19.4625H163.384Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2121_7338",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 37
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000004505095009009511060000002077860786527136435_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M32.7974 14.3446C34.9826 16.6291 34.9826 20.3709 32.7974 22.6554L21.193 34.7867C19.0078 37.0711 15.4285 37.0711 13.2433 34.7867L1.63893 22.6554C-0.546309 20.3709 -0.546309 16.6291 1.63893 14.3446L13.2433 2.21335C15.4285 -0.071116 19.0078 -0.071116 21.193 2.21335L32.7974 14.3446Z",
    fill: "white"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2121_7338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M33.2869 22.0238L20.1001 8.23822L23.491 4.69336L36.6778 18.4789L33.2869 22.0238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M17.1984 5.32556L13.8075 1.7807L17.1984 -1.76416L20.5893 1.7807L17.1984 5.32556Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M30.3479 25.0962L26.9193 21.5513L17.2365 31.6738L4.65253 18.3215L14.26 8.27777L10.8692 4.73291L1.26165 14.7373L1.22397 14.6979L-2.20459 18.2428L17.2365 38.8423L20.6274 35.2975V35.2581L30.3479 25.0962Z",
    fill: "white"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashinvoiceWhiteLogo);
export default __webpack_public_path__ + "static/media/cashinvoice-white-logo.a58eb91df5626bbfb6649023f47adde9.svg";
export { ForwardRef as ReactComponent };